var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusGallery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.735,
    height: 10.735,
    viewBox: "0 0 10.735 10.735",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.867) rotate(45)"
  }, /*#__PURE__*/React.createElement("line", {
    stroke: "#a2a5b9",
    y2: 9.735,
    transform: "translate(6.884 0) rotate(45)"
  }), /*#__PURE__*/React.createElement("line", {
    stroke: "#a2a5b9",
    y2: 9.735,
    transform: "translate(6.884 6.884) rotate(135)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusGallery);
export default __webpack_public_path__ + "static/media/plus_gallery.21019b2eea6d4f590cb6d969fd01864d.svg";
export { ForwardRef as ReactComponent };